import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
    selector: 'app-embed-redirect',
    standalone: true,
    template: '',
})
export class EmbedRedirectComponent implements OnInit {
    constructor(
        private _route: ActivatedRoute,
        private _router: Router
    ) {}

    ngOnInit(): void {
        const segments = this._route.snapshot.url.map(segment => segment.path);

        if (segments[0] === 'embed') {
            segments.shift();
        }

        if (segments.length === 0) {
            this._router.navigate(['/acceso-denegado']);
            return;
        }

        const queryParams = { ...this._route.snapshot.queryParams };
        delete queryParams.token;

        this._router.navigate(['/', ...segments], {
            queryParams: {
                ...queryParams,
                layout: 'empty',
                embed: '1',
            },
            replaceUrl: true,
        });
    }
}
